










































import { ref, computed, defineComponent } from '@vue/composition-api';
import { exposure } from 'byted-vui/src/directives/exposure';
import { dayjs } from '@tt4b/ttam-utils';
import { trackEvent } from './../../../utils/index';

const GuideWarningType = {
  bubble: 'bubble',
  dot: 'dot',
};

/**
 * 新手引导组件（蓝色闪烁气泡 + popover 点击提示框）
 *
 * 2022-11-21 新增 slot：
 * 1. slot: wrapperContent (点击后不会和引导一起消失，但是引导消失之前，是通过hover/click这个元素触发引导)
 * 2. slot: warningDot (给用户提示的样式，例如蓝色气泡、小红点，默认为蓝色气泡)
 */
const name = 'ttam-popover-on-guide';
export default defineComponent({
  name,
  directives: { exposure },
  props: {
    // 是否展示过的标识id
    guideId: {
      type: [Number, String],
      required: true,
    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    content: {
      type: String,
      default: '',
    },
    btnTitle: {
      type: String,
      default: '',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    title: {
      type: String,
      default: '',
    },
    disableBtn: {
      type: Boolean,
      default: false,
    },
    contentKey: {
      type: String,
      default: '',
    },
    displayDays: {
      type: Number,
      default: 7,
    },
    warningType: {
      type: String,
      default: GuideWarningType.bubble,
    },
  },
  setup(props, { emit }) {
    const visible = ref(true);
    const isShowPopover = ref(false);
    const storageKey = computed(() => `common_guide_popover_${props.guideId}`);
    let firstDisplayedTime = Number(window.localStorage.getItem(storageKey.value));
    if (!firstDisplayedTime) {
      firstDisplayedTime = Date.now();
      window.localStorage.setItem(storageKey.value, String(firstDisplayedTime));
    }
    const MAX_DAY = 7;
    const maxDay = props.displayDays || MAX_DAY;
    visible.value = dayjs().isBefore(dayjs(firstDisplayedTime).add(maxDay, 'day'));
    const handleGotIt = () => {
      isShowPopover.value = false;
      visible.value = false;
      window.localStorage.setItem(storageKey.value, '1');
      trackEvent('guide_adopt', {
        guide_content: props.contentKey,
        button_name: 'common_i_know',
      });
    };
    const handleIsPopoverShow = emitType => {
      if (emitType === props.trigger && visible.value) {
        isShowPopover.value = true;
      }
    };
    return {
      name,
      visible,
      isShowPopover,
      storageKey,
      GuideWarningType,
      handleGotIt,
      handleIsPopoverShow,
    };
  },
});
